import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronRight, ChevronLeft } from "lucide-react";
import { CarouselProps } from "../types/types";
import styles from "./Carousel.module.css";
import { useNavigate } from "react-router-dom";

const Carousel: React.FC<CarouselProps> = ({
  slides,
  autoPlay = true,
  interval = 5000,
}) => {
  const [index, setIndex] = useState<number>(0);
  const navigate = useNavigate();

  const handleCTA = () => {
    navigate("/fine-arts");
  };

  const nextSlide = (): void => {
    setIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = (): void => {
    setIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  useEffect(() => {
    if (!autoPlay) return;
    const timer = setInterval(nextSlide, interval);
    return () => clearInterval(timer);
  }, [index, autoPlay, interval]);

  return (
    <div className={styles.container}>
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          className={styles.slide}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div
            className={styles.bgImage}
            style={{ backgroundImage: `url(${slides[index].image})` }}
          />
        </motion.div>
      </AnimatePresence>

      <div className={styles.lowerOverlayWrapper}>
        <div className={styles.enrollmentBoxSmall}>
          <h2 className={styles.titleSmall}>
            Now Enrolling for <br /> 2025-26 Season
          </h2>
          <button className={styles.ctaButtonSmall} onClick={handleCTA}>
            View Courses
          </button>

          <div className={styles.indicatorsSmall}>
            {slides.map((_, i) => (
              <div
                key={i}
                className={`${styles.dotSmall} ${
                  i === index ? styles.activeDotSmall : ""
                }`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className={`${styles.navButton} ${styles.left}`}
        aria-label="Previous"
      >
        <ChevronLeft size={40} strokeWidth={1.5} />
      </button>
      <button
        onClick={nextSlide}
        className={`${styles.navButton} ${styles.right}`}
        aria-label="Next"
      >
        <ChevronRight size={40} strokeWidth={1.5} />
      </button>
    </div>
  );
};

export default Carousel;
